<template>
  <div>
    <h3>Line Login</h3>
  </div>
</template>

<script>
// sdk.js is loaded with defer, so wait until window.liff exists
const waitLiff = () =>
  new Promise((resolve) => {
    const check = () => (window.liff ? resolve(window.liff) : setTimeout(check, 50));
    check();
  });
export default {
  data() {
    return {};
  },
  async created() {
    const liff = await waitLiff();
    console.log("hello");
    console.log("line", liff);
    liff
      .init({
        liffId: "1655557892-VZMnBojD",
      })
      .then(() => {
        if (!liff.isLoggedIn()) {
          liff.login();
        } else {
          const accessToken = liff.getAccessToken();

          console.log("accestoken :::" + accessToken);

          liff.getProfile().then(function (profile) {
            console.log("profile:::", profile.userId);
            //   localStorage.idLine = profile.userId;
            //   this.$store.dispatch("addidLine", profile.userId);
          });

          // console.log("local:::", localStorage.idLine);

          console.log("liff init success");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
